import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-display-categories',
  templateUrl: './display-categories.component.html',
  styleUrls: ['./display-categories.component.scss']
})
export class DisplayCategoriesComponent implements OnInit {
  @Input() categories: string[] = [];

  constructor() {}

  ngOnInit(): void {}
}
